import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import { isEmptyOrUndefined } from "@/Helpers/isNotEmptyOrUndefined";
import { QuotesColumnSectionHeader } from "./QuotesColumnSectionHeader";
import { QuotesReferenceNumber } from "./QuotesReferenceNumber";
import { QuotesSecondaryText } from "./QuotesSecondaryText";
import { QuotesModifyLink } from "./QuotesModifyLink";
import { QuotesTextLink } from "./QuotesTextLink";

function describeBoothNumber(boothNumber: string | undefined) {
  if (boothNumber === undefined) {
    return undefined;
  }

  if (isEmptyOrUndefined(boothNumber)) {
    return undefined;
  }

  if (boothNumber.toLowerCase().includes("booth")) {
    return boothNumber;
  } else {
    return `Booth: ${boothNumber}`;
  }
}

export function QuotesNotesSection(props: {
  reference: string | undefined;
  // Unpacked server-side from the reference for Amazon warehouse deliveries
  amazonReferenceId?: string | undefined;
  amazonShipmentId?: string | undefined;
  boothNumber: string | undefined;
  notes: string | undefined;
  locationType: string | undefined;
  onModify: (() => void) | undefined;
}) {
  const { notes, reference, boothNumber, locationType } = props;

  const isAmazonReference =
    props.amazonReferenceId !== undefined ||
    props.amazonShipmentId !== undefined;

  const missingNotes = notes === undefined || notes === "";
  const missingReference = reference === undefined || reference === "";
  const missingBoothNumber =
    isEmptyOrUndefined(boothNumber) || locationType !== LocationType.TradeShow;
  const hasBoothNumber = !missingBoothNumber;

  const empty = missingNotes && missingReference && missingBoothNumber;

  return (
    <>
      <QuotesColumnSectionHeader>
        Reference Number &amp; Notes
      </QuotesColumnSectionHeader>
      {reference && (
        <QuotesReferenceNumber>
          {isAmazonReference ? (
            <div className="flex flex-col flex-nowrap items-start">
              {props.amazonReferenceId && (
                <div>Amazon Ref ID: {props.amazonReferenceId}</div>
              )}
              {props.amazonShipmentId && (
                <div>Amazon Shipment ID: {props.amazonShipmentId}</div>
              )}
            </div>
          ) : (
            <div>Reference: {reference}</div>
          )}
        </QuotesReferenceNumber>
      )}
      {notes && <QuotesSecondaryText>{notes}</QuotesSecondaryText>}
      {hasBoothNumber && (
        <QuotesSecondaryText>
          {describeBoothNumber(boothNumber)}
        </QuotesSecondaryText>
      )}
      {empty && <QuotesSecondaryText>Nothing specified</QuotesSecondaryText>}
      {props.onModify && (
        <QuotesModifyLink>
          <QuotesTextLink onClick={props.onModify}>Change</QuotesTextLink>
        </QuotesModifyLink>
      )}
    </>
  );
}
